import React from 'react';
import PropTypes from 'prop-types';
import {Paper, List, Subheader, TextField} from 'material-ui';
import style from "../../../styles/styles";
import componentStyle from "./FirebaseSetting.css";
import Loading from "../../common/Loading/Loading";
import withTranslation from "../../../hoc/withTranslation";
import RaisedButton from 'material-ui/RaisedButton';
import { red500 } from 'material-ui/styles/colors';

class FirebaseSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func
    };

    static defaultProps = {
        app: null,
        loading: false
    };


    handleFile = ({ target }) => {
        if (target.files.length > 0) {
            this.props.editConfiguration('firebase_configuration_file', target.files[0], true);
        }
    };

    handleRemoveFile = () => {
        this.props.editConfiguration('firebase_configuration_file', null);
    };
    handleApiKey = (event) => {
        this.props.editConfiguration('firebase_api_key', event.target.value);
    };

    render() {
        const {loading, app} = this.props;
        let content;
        if (loading ||!app) {
            content = <Loading paper={false}/>;
        } else if (app.configurations.firebase_configuration_file === null) {
            content = <div>
                <p>{this.props.t('module.firebase.firebase_configuration_file')}</p>
                <TextField
                    accept="application/json"
                    fullWidth={true}
                    onChange={this.handleFile}
                    type="file"
                    underlineShow={false}
                />
            </div>
        } else {
            content = <div style={componentStyle.content}>
                <p style={componentStyle.okContent}>
                    <span>{this.props.t('module.firebase.configuration_ok')}</span>
                    <RaisedButton
                        label={this.props.t('module.firebase.remove_configuration')}
                        type="button"
                        onClick={this.handleRemoveFile}
                        backgroundColor={red500}
                    />
                </p>
            </div>
        }

        return <Paper>
            <List>
                <Subheader style={{...style.subHeader, ...style.relative}}>
                    {this.props.t('module.firebase.configuration')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                    <TextField
                        floatingLabelText={this.props.t('module.firebase.firebase_api_key')}
                        defaultValue={app.configurations.firebase_api_key}
                        fullWidth={true}
                        onBlur={this.handleApiKey}
                    />
                </div>
            </List>
        </Paper>
    }
}

export default withTranslation(FirebaseSetting);



// WEBPACK FOOTER //
// src/components/common/FirebaseSetting/FirebaseSetting.js